export enum Roles {
  Sales = "SALES",
}
